import { Link } from "react-router-dom";
import { ArrowRight, ChevronDown } from "lucide-react";

/**
 * Mobile navigation group with sub-links. Replaces the desktop mega menus on phones/tablets: a plain row that expands into a
 * compact list, each entry with a small (112px, ~3 KB) thumbnail. Only one group is open at a time (state lives in Header).
 * When `showAll` is set the first row ("All …") goes to the section's landing page.
 */
export default function MobileNavAccordion({ id, label, to, allLabel, showAll = true, items, open, onToggle, onNavigate }) {
  const panelId = `mobile-nav-${id}-panel`;
  return (
    <div className="border-b border-gray-100" data-testid={`mobile-nav-${id}`}>
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        aria-controls={panelId}
        className="flex w-full items-center justify-between py-3 text-left text-[15px] font-semibold tracking-wide text-[#1A2F4A] hover:text-[#003F8E] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2563EB]"
      >
        {label}
        <ChevronDown className={`h-4 w-4 text-[#667085] transition-transform duration-300 ${open ? "rotate-180" : ""}`} aria-hidden="true" />
      </button>
      {open && (
        <ul id={panelId} className="pb-3">
          {showAll && (
            <li>
              <Link to={to} onClick={onNavigate} className="flex items-center justify-between rounded-lg px-1 py-2.5 text-[14px] font-semibold text-[#2563EB]">
                {allLabel || `All ${label}`}
                <ArrowRight className="h-4 w-4" aria-hidden="true" />
              </Link>
            </li>
          )}
          {items.map((it) => (
            <li key={it.href}>
              <Link to={it.href} onClick={onNavigate} className={`flex items-center gap-3 rounded-lg px-1 text-[14px] font-medium text-[#13233F] active:bg-[#F1F6FF] ${it.tile ? "py-1.5" : "py-2"}`}>
                {it.thumb && it.tile ? (
                  // product photography: the whole machine on a light 72 px tile (object-contain, never cropped)
                  <span className="flex h-[72px] w-[72px] shrink-0 items-center justify-center rounded-xl bg-[#F5F7FA]">
                    <img src={it.thumb} alt="" width={it.thumbW || 72} height={it.thumbH || 72} loading="lazy" decoding="async" className="h-auto max-h-[88%] w-auto max-w-[88%] object-contain" />
                  </span>
                ) : it.thumb ? (
                  <img src={it.thumb} alt="" width="44" height="44" loading="lazy" decoding="async" className="h-11 w-11 shrink-0 rounded-lg object-cover" />
                ) : (
                  <span className="h-11 w-11 shrink-0 rounded-lg bg-[#F1F4F9]" aria-hidden="true" />
                )}
                <span className="min-w-0 flex-1 leading-snug">{it.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
